import $ from 'expose-loader?exposes=$,jQuery!jquery'
import PhotoSwipe from 'photoswipe/lightbox'

const pswpTemplate = '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n' +
  '    <div class="pswp__bg"></div>\n' +
  '    <div class="pswp__scroll-wrap">\n' +
  '        <div class="pswp__container">\n' +
  '            <div class="pswp__item"></div>\n' +
  '            <div class="pswp__item"></div>\n' +
  '            <div class="pswp__item"></div>\n' +
  '        </div>\n' +
  '        <div class="pswp__ui pswp__ui--hidden">\n' +
  '            <div class="pswp__top-bar">\n' +
  '                <div class="pswp__counter"></div>\n' +
  '                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n' +
  '                <button class="pswp__button pswp__button--download" title="Download"></button>\n' +
  '                <div class="pswp__preloader">\n' +
  '                    <div class="pswp__preloader__icn">\n' +
  '                        <div class="pswp__preloader__cut">\n' +
  '                            <div class="pswp__preloader__donut"></div>\n' +
  '                        </div>\n' +
  '                    </div>\n' +
  '                </div>\n' +
  '            </div>\n' +
  '            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n' +
  '                <div class="pswp__share-tooltip"></div>\n' +
  '            </div>\n' +
  '            <button class="pswp__button pswp__button--arrow--left" title="Previous"></button>\n' +
  '            <button class="pswp__button pswp__button--arrow--right" title="Next"></button>\n' +
  '            <div class="pswp__caption">\n' +
  '                <div class="pswp__caption__center"></div>\n' +
  '            </div>\n' +
  '        </div>\n' +
  '    </div>\n' +
  '</div>'

const parseThumbnailElements = el => {
  let hbfileElements = $(el).find('.hbfile'),
    items = [],
    item

  $(hbfileElements).each(function () {
    const self = $(this)
    if (isImage(self)) {
      items.push({
        dsrc: self.attr('data-download-url'),
        src: self.attr('data-preview-url'),
        w: 0,
        h: 0,
        title: self.attr('data-title'),
        el: this
      })
    }
  })

  return items
}

const isImage = el => {
  const type = $(el).attr('data-type')
  if (!type) {
    return false
  }

  return ['png', 'jpg', 'jpeg', 'gif'].includes(type)
}

const onThumbnailsClick = e => {
  e = e || window.event;
  const eTarget = e.target || e.srcElement,
    hbfile = $(eTarget).closest('.hbfile')

  if (isImage(hbfile)) {
    e.preventDefault ? e.preventDefault() : e.returnValue = false
  } else {
    if (hbfile.attr('data-download-url'))
      window.open(hbfile.attr('data-download-url'))

    return false
  }

  let clickedGallery = $(hbfile).closest('.hbfiles'),
    index

  index = clickedGallery.find('.hbfile.hbfile-image').index(hbfile)

  if (index >= 0) {
    openPhotoSwipe(index, clickedGallery)
  }
  return false
}

const openPhotoSwipe = (index, galleryElement) => {
  const pswpElement = document.querySelectorAll('.pswp')[0]

  const items = parseThumbnailElements(galleryElement)
  options = {
    galleryUID: $(galleryElement).attr('data-pswp-uid'),
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
    bgOpacity: 0.8,
    history: false,
    index: index,
    shareButtons: [
      {id: 'download', label: 'Download image', url: '{{raw_image_url}}', download: true}
    ],
    getImageURLForShare: item => gallery.currItem.dsrc || '',
    getThumbBoundsFn: index => {
      const img = items[index].el.getElementsByTagName('img')
      const hbfile = items[index].el.getElementsByTagName('img')[0]
      const pageYScroll = window.pageYOffset || document.documentElement.scrollTop

      if (!hbfile) {
        return false
      }

      const rect = hbfile.getBoundingClientRect()

      return {
        x: rect.left,
        y: rect.top + pageYScroll,
        w: rect.width
      }
    }
  }
  options.index = parseInt(index, 10)
  if (isNaN(options.index)) {
    return
  }
  $('body').append(pswpTemplate)

  const gallery = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, options)
  gallery.listen('imageLoadComplete', (index, item) => {
    if (item.h < 1 || item.w < 1) {
      const img = new Image()
      $(img).on('load', function () {
        item.w = img.width
        item.h = img.height
        gallery.invalidateCurrItems()
        gallery.updateSize(true)
      })
      img.src = item.src
    }
  })
  gallery.init()
}

export default {
  init: function (gallerySelector) {
    gallerySelector = gallerySelector || '.hbfiles'
    $(gallerySelector).each(function (i) {
      const gallery = $(this)
      gallery.find('.hbfile').each(function() {
        const file = $(this),
          type = file.attr('data-type'),
          placeholder = file.find('img.hbfile-placeholder')
        if (isImage(file)) {
          file.addClass('hbfile-image')
          placeholder.attr('src', file.attr('data-thumbnail-url'))
        } else {
          placeholder.remove()
          file.find('.hbfile-placeholder-box')
            .append('<div class="hbfile-placeholder hbfile-placeholder-empty"><i class="fa-solid fa-paperclip-vertical"></i><div>'+(type ? type : '')+'</div></div>');
        }
      })
      gallery.attr('data-pswp-uid', i + 1).on('click', '.hbfile-placeholder-box', onThumbnailsClick)
    })
  }
}
